import React, { useState } from 'react';
import SelectStudent from '../../../studentTransfer/components/selectStudent';
import { useSearchStudentsHandler } from '../../../studentTransfer/customHooks';
import { searchStudents } from '../searchStudent/constants';
import { useWizard } from '../../../../components/wizard/WizardContext';
import { getColumnList } from './tableColumnsConfig';
import FilterForm from './FilterForm';
import RefundTipsCard from './RefundTipsCard';
import SelectStudentFooter from '../../../studentTransfer/components/selectStudent/SelectStudentFooter';
import { COMPLETION_REFUND, MULTI_TYPE_REFUND, RECTIFICATION_REFUND, refundStepsEmptyForms } from '../config';
import ALoader from '../../../../views/pages/manage/common/a-loader';

const SelectStudentWrapper = () => {

    const { next, values, setValues, dropdowns } = useWizard();
    const { selectedStudent, rectRefundStep2Data, refundType, multiTypeRefundStep2Data, completionRefundStep2Data } = values;
    const { searchHandler } = useSearchStudentsHandler();
    const handleSearch = (...args) => searchHandler(...args, searchStudents);

    const { value: refundTypeKey, validateStudent } = values?.refundType;

    const [loading , setLoading] = useState(false);


    const validate = async() => {
        try{
            setLoading(true);

        let prevSelectedStudentAppId;

        switch (refundType?.value) {
            case MULTI_TYPE_REFUND: {
                prevSelectedStudentAppId = multiTypeRefundStep2Data?.selectedStudentAppId
                break;
            }
            case RECTIFICATION_REFUND: {
                prevSelectedStudentAppId = rectRefundStep2Data?.selectedStudentAppId
                break;
            }
            case COMPLETION_REFUND: {
                prevSelectedStudentAppId = completionRefundStep2Data?.selectedStudentAppId
                break;
            }
        }


        if (selectedStudent?.applicationId !== prevSelectedStudentAppId) {
            setValues(vals => ({ ...vals, ...refundStepsEmptyForms }))
        }

        if (! await validateStudent(selectedStudent, dropdowns?.data)) return;

        next();
    }catch(err){
        console.error(err);
    }finally{
        setLoading(false);
    }
    }

    return (
        <>
          {loading && <ALoader position={"fixed"}/>}
            <div className='d-flex'>
                <SelectStudent
                    searchHandler={handleSearch}
                    getColumnList={getColumnList}
                    FilterForm={FilterForm}
                />

                <RefundTipsCard
                    key={refundTypeKey}
                />
            </div>

            <SelectStudentFooter
                validate={validate}
                selectedStudent={selectedStudent}
            />


        </>
    );
}

export default SelectStudentWrapper;